import * as React from 'react';
import capitalize from 'lodash/capitalize';
import memoize from 'lodash/memoize';
import { Promotion, Maybe } from '@css-xp/graphtypes';
import { renderPartnerPromotionValue, getPromotionTitle, DynamicResultTable } from '@css-xp/base';
import {
  emptyStatePropDiscountTable,
  NoData,
  TableHeading,
  emptyStatePropDiscountTableDesignIteration1,
} from '@css-xp/ppc-common';
import './discount-table.scss';

export interface AppliedDiscounts extends Promotion {
  billingCycle?: string;
  billingFrequency?: string | null;
}

interface Props {
  promotions: Maybe<AppliedDiscounts>[];
  isDesignIteration1Enabled?: boolean;
}

const getHead = memoize((isDesignIteration1Enabled: boolean | undefined, totalCount?: number) => {
  const columns = [
    {
      content: isDesignIteration1Enabled ? 'Discount type' : 'Discount',
      width: isDesignIteration1Enabled ? 20 : 30,
    },
    {
      content: isDesignIteration1Enabled ? 'Description' : 'Details',
      width: isDesignIteration1Enabled ? 20 : 50,
    },
    {
      content: 'Billing cycle',
      width: 20,
    },
  ];

  return {
    cells: totalCount ? columns : [],
  };
});

const DiscountTable = ({ promotions, isDesignIteration1Enabled }: Props) => {
  const totalCount = promotions?.length || 0;
  const getRows = () => {
    return promotions.map((promotion, index) => {
      return {
        key: `applied-discount-${index}`,
        testId: `applied-discount-details`,
        cells: [
          {
            key: 'type' + index,
            content: getPromotionTitle(promotion, { handleEmptyTitle: true }),
          },
          {
            key: 'details' + index,
            content: renderPartnerPromotionValue(promotion, {
              showDuration: true,
              showReason: true,
              isMonthlyPlan: promotion?.billingFrequency === 'MONTHLY',
            }),
          },
          {
            key: 'billing cycle' + index,
            content: promotion?.billingCycle ? capitalize(promotion?.billingCycle) : <NoData />,
          },
        ],
      };
    });
  };

  return (
    <div className="applied-discount-details-table-ppc">
      <DynamicResultTable
        testId="applied-discount-details"
        head={getHead(isDesignIteration1Enabled, totalCount)}
        rows={getRows()}
        beforeTable={!isDesignIteration1Enabled ? <TableHeading>Active discounts</TableHeading> : <></>}
        emptyStateProps={
          isDesignIteration1Enabled ? emptyStatePropDiscountTableDesignIteration1 : emptyStatePropDiscountTable
        }
        loadingSpinnerSize="large"
        isLoading={false}
        totalCount={totalCount}
        hideHeadOnEmptyState={isDesignIteration1Enabled}
      />
    </div>
  );
};

export default DiscountTable;
